import gql from 'graphql-tag';

import dokkioLabelFragment from '../fragments/dokkioLabelFragment';

export const mutationMergeDokkioLabels = gql`
  mutation mergeDokkioLabels (
    $primaryDokkioLabelID: DokkioID!
    $secondaryDokkioLabelID: DokkioID!
  ) {
    mergeDokkioLabels (
      primaryDokkioLabelID: $primaryDokkioLabelID
      secondaryDokkioLabelID: $secondaryDokkioLabelID
    ) {
      ...dokkioLabelFragment
    }
  }
  ${dokkioLabelFragment}
`;

export default mutationMergeDokkioLabels;
